import React, { useEffect, useState } from 'react';
import { Styles } from '../../../../../config/design/styles';
import { withStyles } from "@mui/styles";
import { connect } from "trim-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { LineChart } from "@mui/x-charts/LineChart";
import { defaultVariables } from "../../../../../config";
import moment from 'moment';

const StockPriceChart = ({ classes, user, setting }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({ normal: [], special: [] });
    const navigate = useNavigate();
    const loginToken = localStorage.getItem('ACT');

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }

    const loadData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${defaultVariables.url}/stock-price/get-chart`, config);
            setData(response.data);
        } catch (error) {
            console.error("Error fetching stock prices:", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadData();
    }, []);
    useEffect(() => {
        loadData();
    }, [setting.current_normal_price,setting.current_special_price]);

    return (
        <>
            {!loading && (
                <div>
                    <LineChart
                        dataset={data.normal_prices.map((item, index) => ({
                            x: moment(data.dates[index]).format("MMM D"),
                            normal: item,
                            special: data.special_prices[index] || null
                        }))}
                        xAxis={[{ dataKey: "x", scaleType: "band", label: "Days" }]}
                        series={[
                            { dataKey: "normal", label: "Normal Price", color: "#00c3d2" },
                            { dataKey: "special", label: "Special Price", color: "#00ff89" }
                        ]}
                        height={300}
                        margin={{ left: 50, right: 50, top: 60, bottom: 50 }}
                        grid={{ vertical: true, horizontal: true }}
                    />
                </div>
            )}
        </>
    );
};

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    setting: state.setting,
});

export default withStyles(Styles)(connect(mstp)(StockPriceChart));